import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserVerify = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.205 14.1c-2.736.122-4.879.718-4.879 2.457 0 1.567 1.731 2.216 4.081 2.422M13.575 13.431a.97.97 0 0 0-.971.971l-.001.44a.97.97 0 0 1-.283.685l-.31.31-.003.003-.002.002a.97.97 0 0 0 .007 1.372l.308.31a.97.97 0 0 1 .284.684v.444c0 .536.434.97.97.97h.442c.256 0 .502.103.684.283l.308.309.004.004.002.001a.97.97 0 0 0 1.373-.006l.309-.309a.97.97 0 0 1 .684-.283h.444a.97.97 0 0 0 .971-.97v-.442c0-.257.102-.503.282-.685l.31-.309.004-.003a.97.97 0 0 0-.005-1.374l-.308-.31a.97.97 0 0 1-.283-.684v-.442a.97.97 0 0 0-.971-.972h-.443a.97.97 0 0 1-.684-.282l-.313-.312v-.001a.97.97 0 0 0-1.375.004l-.308.31a.98.98 0 0 1-.684.282z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.373 16.58.873.874 1.798-1.8"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.292 7.382a3.885 3.885 0 1 1-7.77 0 3.885 3.885 0 0 1 7.77 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserVerify);
export default ForwardRef;
